import { render, staticRenderFns } from "./inspectionDetail.vue?vue&type=template&id=53691fda&scoped=true"
import script from "./inspectionDetail.vue?vue&type=script&lang=js"
export * from "./inspectionDetail.vue?vue&type=script&lang=js"
import style0 from "./inspectionDetail.vue?vue&type=style&index=0&id=53691fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53691fda",
  null
  
)

export default component.exports